import { twMerge } from 'tailwind-merge';

export const Background = ({ className }: { className?: string }) => (
  <div
    className={twMerge(
      "bg-[url('/images/background.jpg')] bg-cover bg-center",
      className
    )}
  />
);
